import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media";

const JunoHeading = styled.h1`
  font-family: var(--juno-font-family-body);
  font-style: normal;
  line-height: 1.25em;
  font-weight: var(--juno-font-weight-bold);

  margin-bottom: 0.5em;
  ${mediaQueries.md} {
    margin-bottom: 0.75em;
  }
  ${mediaQueries.lg} {
    margin-bottom: 1em;
  }

  &.h1 {
    margin-bottom: 1em;
    font-size: var(--juno-font-size-h1-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h1-md);
    }
  }

  &.h2 {
    font-size: var(--juno-font-size-h2-sm);
    margin-left: -0.02em;
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h2-md);
    }
  }

  &.h3 {
    font-size: var(--juno-font-size-h3-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h3-md);
    }
  }

  &.h4 {
    font-size: var(--juno-font-size-h4-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h4-md);
    }
  }
`;

// styled(Heading) passes its generated class in className. Merge it with the
// size class, or the wrapper class replaces the size and the heading loses it.
const Heading = ({ level = 1, size = null, className, ...props }) => {
  const sizeClass = size ? `h${size}` : `h${level}`;
  return <JunoHeading as={`h${level}`} {...props} className={`${sizeClass} ${className ?? ""}`.trim()} />;
};

export default Heading;
